import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {


  constructor(private router: Router) {
  };

  goToDashboard() {
    this.router.navigate(['/dashboard/']);
  }
  goToBalance() {
    this.router.navigate(['/balance/']);
  }
  gotoBlockCard() {
    this.router.navigate(['/blockcard/']);
  }
  gotoBlockCards() {
    this.router.navigate(['/blockcards/']);
  }
  gotoBlockyourcard(id: number) {
    this.router.navigate(["/blockcards/" + "/blockyourcard/" + id]);
  }
  goToWalletTransfer()
  {
    this.router.navigate(['/wallettransfer/']);
  }
  gotoStatement(){
    this.router.navigate(['/statements/']);

  }
  goTowalletAmount(id,actionInfo){
    this.router.navigate(['/wallettransfer/'+id,actionInfo]);
  }
}
